export default "__VITE_ASSET__DoqXLvHa__"